/** Clients API calls (typed). Bodies are mapped via the adapter. */

import { apiDelete, apiGet, apiPatch, apiPost, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiClient } from "./clients.adapter";
import { toClientWriteBody } from "./clients.adapter";
import type { ClientFormValues } from "./components/ClientFormModal";

export interface ClientsListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string; // a concrete ClientStatus (never "all")
  type?: string;
  level?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const clientsApi = {
  list: (params: ClientsListParams = {}) =>
    apiGet<PaginatedResponse<ApiClient>>("/clients", params as QueryParams),
  get: (id: string) => apiGet<ApiClient>(`/clients/${id}`),
  create: (values: ClientFormValues) => apiPost<ApiClient>("/clients", toClientWriteBody(values)),
  update: (id: string, values: ClientFormValues) =>
    apiPatch<ApiClient>(`/clients/${id}`, toClientWriteBody(values)),
  archive: (id: string) => apiDelete<ApiClient>(`/clients/${id}`),
  restore: (id: string) => apiPost<ApiClient>(`/clients/${id}/restore`),
};
